<!--今日线索任务-->
<template>
  <article>
    <scroller
      lock-x scrollbar-y
      use-pullup
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      ref="myScroller"
      height="100%">
      <div>
        <group v-for="(item,index) in clueTask" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">姓名：{{item.customer_name}}</p>
            <i slot="value" class="phone-icon-right" @click.stop="makeACall(item.mobile)"></i>
          </cell>

          <cell class="personal-info-detail" @click.native="clueArchives(item.id)">
            <div slot="after-title" class="title-list">
              <p v-for="(v, index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span>
              </p>
            </div>
            <p slot="after-title" class="info">下次致电：{{item.next_contact_at}}</p>
            <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
            <p slot="after-title" class="info">最近联系：{{item.last_contact_at}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
          </cell>

          <cell v-if="(authId ===item.assignee_id)||followAllClue" class="acard-btn">
            <x-button class="visitor-btn" slot="value" mini plain type="primary" @click="addClueRecord(item.id)">添加跟进记录
            </x-button>
          </cell>
        </group>
        <p class="tip-text1">共有{{totalCount}}条线索</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  XButton,
  Cell,
  Group
} from '@lx-frontend/cvux'
import authApi from '../../../common/auth'

export default {
  components: {
    Scroller,
    XButton,
    Cell,
    Group
  },
  data () {
    return {
      pageAuth: [authApi.saleManage.sale_clue_view_self, authApi.saleManage.sale_clue_view_all],
      // 跟进个人线索
      followSingleClue: false,
      // 全部线索任务权限
      followAllClue: false,
      authId: '',
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      page: 1,
      item_per_page: 20,
      totalCount: 0,
      totalPage: 1,
      clueTask: []
    }
  },
  mounted () {
    this.$store.state.promiseAuth.then(auth => {
      let authList = auth.authList
      this.authId = auth.id
      let permission = authApi.haveSomeAuth(this.pageAuth, authList)
      this.followSingleClue = authList.includes(authApi.saleManage.sale_clue_follow_self)
      this.followAllClue = authList.includes(authApi.saleManage.sale_clue_follow_all)
      if (permission) {
        this.$rest.saleManage.todayClueTask({
          page: this.page,
          item_per_page: this.item_per_page
        }).then(res => {
          if (res.code === 0) {
            this.clueTask = res.data.tasks
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          }
        })
      }
    })
  },
  methods: {
    addClueRecord (id) {
      this.$router.push('/salemanage/staff/addcluerecord/' + id)
    },
    makeACall (phone) {
      window.location.href = 'tel:' + phone
    },
    clueArchives (id) {
      if (id) {
        this.$router.push({ path: '/salemanage/staff/cluearchives/', query: { id: id } })
      }
    },
    loadMore (done) {
      if (this.page < this.totalPage) {
        ++this.page
        this.$rest.saleManage.todayClueTask({
          page: this.page,
          item_per_page: this.item_per_page
        }).then(res => {
          if (res.code === 0) {
            this.clueTask.push(...res.data.tasks)
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
            done(100)
          }
        })
      } else {
        done()
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
